<template>
	<div class="section ">
		<div class="layui-container">
			<div class="section-head">
				{{$t('为你推荐')}}
			</div>
			<div class="product-cells">
				<el-row :gutter="isMobileFlag?10:20" class="product-list">
					<el-col :xs="12" :sm="8" :md="6" v-for="(item,index) in discountProducts" :key="index">
						<product-item :item="item" ></product-item>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import productItem from '@/components/productItem.vue'
	export default {
		components: {
			productItem
		},
		props: {
			item: {
				default: () => ({}),
			},
		},
		data() {
			return {};
		},
		computed: {
			discountProducts() {
				return this.item
					.filter(product => product.is_recommend === 1)
					.slice(0, 8);
			}
		},
		methods: {},
		mounted() {}
	}
</script>